const db = {
    data: {
        users: [
            { name: "admin", password: "admin", sports: [], role: "admin" },
            { name: "user", password: "reindasding", sports: [], role: "user" }
        ]
    },
    write: async () => {
        // Simulate async write operation
        return new Promise((resolve) => setTimeout(resolve, 100));
    }
};

export default db;